import React from "react";
import DateInput from "../../components/Date/DateInput";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { FormField, TextObject } from "@/shared/types";

interface DateFieldProps {
  isError?: boolean;
  field: FormField;
  useFormProps: UseFormReturn<FieldValues, any>;
  isSubmitting: boolean;
  text: TextObject;
}

const DateField: React.FC<DateFieldProps> = ({
  isError,
  useFormProps,
  field,
  text,
}) => {
  return (
    <DateInput
      id={field?.id}
      isError={isError}
      fieldSettings={field?.settings || {}}
      fieldControl={useFormProps.control}
      registerProps={{
        ...useFormProps?.register(field?.id, {}),
      }}
      text={text}
    />
  );
};

export default DateField;
